import { useEffect, useState } from "react"

export const useQueryParams = (): { [name: string]: string } => {
  const [params, setParams] = useState(undefined)

  useEffect(() => {
    const temp = {}
    new URLSearchParams(window.location.search).forEach((value, key) => {
      temp[key] = value
    })
    setParams(temp)
  }, [])

  return params
}
